import axiosInstance from "../../core/axiosConfig.ts";

export class CommissionService {
    async createAgency(payload: any) {
        const response = await axiosInstance.post(
            'admin/agency/create',
            payload
        );
        return response.data;
    }
    
    async deleteAgency(id: number) {
        const response = await axiosInstance.delete(
            '/admin/agency/delete', {params : {id}}
        );
    }

    async updateAgency(payload: any) {
        const response = await axiosInstance.patch(
            'admin/agency/update',
            payload
        );
    }
}